import styled from 'styled-components';
import theme from '../../../../constants/theme';

export const Wrapper = styled.div``;

export const ShipmentCard = styled.div`
	margin-top: 3rem;
	box-shadow: 0px 11px 24px #ececec;

	span {
		font-size: 1.4rem;
		display: block;
		text-transform: uppercase;
		font-weight: 700;
		color: ${theme.colors.black};
	}

	a {
		margin-left: 1rem;
		text-decoration: underline;
	}

	div:last-child {
		border-right: 0;
	}

	${({ simple }) =>
		simple &&
		`
			padding: 4rem 3rem 3.5rem 3rem;
			text-align: center;
			border: 3px dashed ${theme.colors.grayLighter};

			svg {
			   margin: 0 1rem 0 0;
			}
		`}

	span {
		font-size: 1.4rem;
		display: block;
		text-transform: uppercase;
		font-weight: 700;
		color: ${theme.colors.black};
	}

	a {
		margin-left: 1rem;
		text-decoration: underline;
	}

	div:last-child {
		border-right: 0;
	}

	${({ simpleIcon }) =>
		simpleIcon &&
		`
            display: flex;
            justify-content: center;
            box-shadow: none;
			padding: 2rem;

			svg {
			    height: 3rem;
			    margin: 0 .5rem 0 0;
			}
		`};

	${({ blue }) =>
		blue &&
		`
			border: 1px solid ${theme.colors.secondaryLight};
			background-color: ${theme.colors.secondaryLightest};
			color: ${theme.colors.black};
			svg {
			    fill: ${theme.colors.secondary};
			}
		`};

	${({ red }) =>
		red &&
		`
			background-color: ${theme.colors.primary};
			color: ${theme.colors.white};
			svg {
			    path { fill: ${theme.colors.white};}
			}
		`};
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4rem;
`;